export default "__VITE_ASSET__$si61TcO__"